var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 96 96",
    height: "96px",
    viewBox: "0 0 96 96",
    width: "96px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dibujo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,58.424V47c0-1.104-0.896-2-2-2c-1.105,0-2,0.896-2,2v11.424c-1.763,0.773-3,2.531-3,4.576c0,2.757,2.243,5,5,5    c2.757,0,5-2.243,5-5C53,60.955,51.763,59.197,50,58.424z M48,64c-0.552,0-1-0.448-1-1s0.448-1,1-1c0.552,0,1,0.448,1,1    S48.552,64,48,64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.009,55.459L56,30c0-4.411-3.589-8-8-8c-4.411,0-8,3.589-8,7.999l-0.01,25.46C38.08,57.492,37,60.192,37,63    c0,6.065,4.935,11,11,11c6.065,0,11-4.935,11-11C59,60.191,57.92,57.491,56.009,55.459z M48,70c-3.859,0-7-3.141-7-7    c0-1.984,0.848-3.885,2.327-5.213c0.422-0.38,0.663-0.92,0.663-1.487L44,30c0-2.206,1.794-4,4-4c2.206,0,4,1.794,4,4.001    L52.009,56.3c0,0.567,0.241,1.108,0.664,1.487C54.151,59.115,55,61.015,55,63C55,66.859,51.859,70,48,70z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.01737b4a8ad508924c0b21c12b3fef8c.svg";
export { ForwardRef as ReactComponent };